import generatorRequest from "../config/generator";

export const exeGenerators = (data) => {
  return generatorRequest.exeGeneratorsFunction(data).then((response) => response);
}
